<template>
  <div class="contain">
    <van-field
      v-model="content"
      rows="3"
      autosize
      label="评价内容"
      type="textarea"
      maxlength="150"
      placeholder="请输入评价内容"
      show-word-limit
    />
    <van-cell center title="是否匿名">
      <template #right-icon>
        <van-switch v-model="checked" size="24" active-color="#f4bf41" />
      </template>
    </van-cell>
    <button v-if="!buttonShow" class="button" @click="submit">提 交</button>
    <button
      v-else
      class="button"
      type="primary"
      style="background-color: #f36e868e; color: white"
      loading="true"
      disabled="true"
    >
      提交中...
    </button>
  </div>
</template>

<script>
import { getOpenId, getUrl, getPlatform } from "@/utils/auth";
import { insertOrderComment } from "@/api/Hotel";
import { Toast } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      buttonShow: false,
      content: "",
      userName: "",
      headImgUrl: "",
      checked: false,
      isAnonymous: "",
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    submit() {
      if (!this.content) {
        this.$toast("请输入评价内容");
        return;
      }
      if (this.checked) {
        this.isAnonymous = 1;
      } else {
        this.isAnonymous = 0;
      }
      let data = {
        userId: getOpenId(),
        content: this.content,
        nickName: this.userName,
        headImgUrl: this.headImgUrl,
        orderId: this.$route.params.orderId,
        goodsId: this.$route.params.goodsId,
        isAnonymous: this.isAnonymous,
        platformId: getPlatform(),
      };
      console.log(data);
      insertOrderComment(data).then((res) => {
        if (res.data.code == 200) {
          Toast.success("评价成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              wx.miniProgram.navigateBack({
                delta: 1,
              });
            } else {
              // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
              this.$router.push("/hotels/orderList/1");
            }
          }, 1000);
        }
      });
    },

    // 获取用户信息
    getUserInfo() {
      var that = this;
      console.log(getUrl(), 111111111);
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/userInfo";
      const params = { userId: getOpenId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.userName = response.data.data.nickName;
          that.headImgUrl = response.data.data.headImgUrl;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
  },
  created() {},
  mounted() {
    this.getUserInfo();
  },
};
</script> 

<style scoped>
.contain {
  padding: 0 10px;
  box-sizing: border-box;
}
/deep/ .van-cell {
  background: #f5f5f5;
  margin-top: 15px;
  border-radius: 5px;
}

.button {
  width: 80%;
  height: 40px;
  line-height: 40px;
  margin: 12px auto;
  background: #f4bf41;
  color: #333333;
  border-radius: 30px;
  bottom: 0;
  position: fixed;
  left: 10%;
  border: none;
}
</style>